export default __webpack_public_path__ + "static/media/linkedin-orange.8950645d.svg";